<div class="m-10">
  <div class="grid grid-cols-12 gap-5 mt-5">
    <!-- BEGIN: Product Detail Side Menu -->
    <div class="box intro-y p-5 col-span-12">
      <div
        class="flex items-center border-b border-slate-200/60 dark:border-darkmode-400 pb-5 mb-5"
      >
        <div class="font-medium truncate text-base">Indemnity</div>
      </div>
      <div class="leading-relaxed">
        <p class="mt-5">Limitation of Liability, Indemnity and Refund Policy</p>
        <p class="mt-5">
          1. What is this document? In broad terms, this is an agreement with
          you that limits liability under certain circumstances for loss, damage
          or injury you may suffer arising from your participation in the event.
          It is important that you read and understand the contents hereof, as
          you will be bound to these terms.
        </p>
        <p class="mt-5">
          2. When does this Limitation of Liability and Indemnity apply to you?
          This Limitation of Liability and Indemnity applies to all
          participants. It does not matter who or how you entered for the event.
          This Limitation of Liability and Indemnity applies to you even if
          someone else submitted your entry. Any person who enters someone else
          for an event warrants that they have been authorised to do so and to
          can legally bind the participant to this agreement.
        </p>
        <p class="mt-5">
          3. Can children participate without their parents’ or guardians’
          consent?
        </p>
        <p class="mt-5">
          No. If you are a minor, i.e. younger than 18, you may not participate
          unless your parent(s) or your legal guardian(s), have agreed to be
          bound by this Limitation of Liability and Indemnity. If you are a
          minor, by giving permission for you to participate in the event, your
          parents or legal guardians agree not to bring any claims against us
          for losses or damages they may suffer as a result of injury or death
          you may have suffered as a result of your participation in the event.
          They also agree to only claim on your behalf for losses, damages and
          injuries you may suffer as a result of your participation in the event
          to extent allowed for in this agreement.
        </p>
        <p class="mt-5">
          IF YOU ARE ENTERING ON BEHALF OF YOUR MINOR, YOU CONFIRM THAT YOU ARE
          DULY AUTHORISED IN LAW TO ACT AND LEGALLY BIND THE MINOR. YOU AGREE TO
          HOLD THE ORGANISER HARMLESS FROM ANY CLAIMS AGAINST THE ORGANISER AS A
          RESULT OF THE ABSENCE OF SUCH LEGAL AUTHORITY.
        </p>
        <p class="mt-5">
          4. Are there risks associated with the event? Yes. It is an event with
          many participants. Some are professionals, but others are novices. The
          event is a large sports event attracting large numbers of
          participants, even more spectators and takes place at high speeds on
          an extended course running over a varied terrain that could include
          urban areas, nature reserves, mountainous terrain and gravel roads.
          You accept that we cannot manage all potential risks, even foreseen
          ones, otherwise it would not be feasible to organise this event.
        </p>
        <p class="mt-5">
          YOU THEREFORE UNDERSTAND THAT THERE ARE RISKS AND HAZARDS ASSOCIATED
          WITH AN EVENT LIKE THIS AND THAT THE POSSIBLE EFFECTS OF THESE RISKS
          CAN RANGE FROM MINOR INJURIES TO SEVERE INJURIES TO DEATH, AND IN
          RELATION TO YOUR PROPERTY CAN RANGE FROM MINOR DAMAGE TO SEVERE DAMAGE
          TO COMPLETE DESTRUCTION OR LOSS.
        </p>
        <p class="mt-5">
          5. Who are covered by this Limitation of Liability and Indemnity?
        </p>
        <p class="mt-5">
          The organisers (including their directors, shareholders and employees)
          are covered by this Limitation of Liability and Indemnity as well as
          the volunteers who help with the event, the local authority where the
          event is held and road maintenance agencies if the event takes place
          on a road under its concession.
        </p>
        <p class="mt-5">
          6. Who are NOT covered by this Limitation of Liability and Indemnity?
        </p>
        <p class="mt-5">
          Doctors, paramedics and other medical personnel who attend to you at
          the event do so independently from us and they are not our
          representatives. It is your choice to make use of these services and
          you do so at your own risk.
        </p>
        <p class="mt-5">
          7. Can you claim from us for any loss, damage or injuries you suffer?
        </p>
        <p class="mt-5">
          AS FAR AS THE LAW ALLOWS, WE ARE NOT LIABLE TO YOU FOR ANY LOSS,
          DAMAGE, INJURIES OR DEATH YOU MAY SUFFER FROM PARTICIPATING IN THIS
          EVENT UNLESS THE LOSS, DAMAGE, INJURIES OR DEATH RESULTED FROM OUR
          FAULT. THIS LIMITATION ALSO APPLIES TO ACTIVITIES ASSOCIATED WITH, OR
          INCIDENTAL TO, THE EVENT OR FROM USING ANY FACILITIES OR SERVICES
          WHICH ARE PROVIDED AT THE EVENT BY THE PARTIES COVERED IN PARAGRAPH 5
          ABOVE. WE DO NOT UNDER ANY CIRCUMSTANCES ACCEPT LIABILITY FOR ANY
          INDIRECT, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGE. THE EVENT IS
          ORGANISED ON A BEST EFFORT BASIS AND ALL WARRANTIES AS TO THE QUALITY
          OF THE EVENT ARE DISCLAIMED TO THE MAXIMUM EXTENT PERMISSIBLE AT LAW.
        </p>
        <p class="mt-5">
          8. Can anybody other than the participant (such as dependents) who
          suffered damages else claim against us?
        </p>
        <p class="mt-5">
          YOU AGREE THAT THIS LIMITATION OF OUR LIABILITY APPLIES TO YOU, YOUR
          ESTATE AND YOUR DEPENDENTS. Parents, legal guardians or dependents of
          a participant may claim against us, but only insofar as the
          participant who suffered the damages in the first place had a claim
          against us under the abovementioned clause and subject always to the
          terms of this Limitation of Liability and Indemnity in respect of such
          claim by the participant.
        </p>
        <p class="mt-5">
          YOU AGREE TO HOLD US HARMLESS FROM ANY CLAIMS AGAINST US BY OTHER
          PARTIES (SUCH AS YOUR SPOUSE, DEPENDENTS) AS A RESULT OF YOUR LOSS,
          DAMAGE, INJURY OR DEATH.
        </p>
        <p class="mt-5">
          9. Are there any other rules that apply to the event? Yes. The rules
          for each event are available on the webpage for the event or upon
          request from the event organiser. Our rules are there to promote your
          safety, and you agree to stick to the rules of the event and to obey
          our instructions.
        </p>
        <p class="mt-5">
          Other rules also apply to the event, such as the rules of sporting
          codes or bodies, the road, local government rules and any rules that
          apply to a facility or area used for the event. As a minimum the
          following rules apply for the event:
        </p>
        <ul class="mt-5 sm:mt-3 list-disc sm:ml-5">
          <li class="mb-1 last:mb-0">
            The event is open to any participant with their equipment, such as a
            bicycle or running shoes, in good working order.
          </li>
          <li class="mb-1 last:mb-0">
            Communication on event related matters may be done by e-mail, SMS,
            WhatsApp and/or social media. It is each entrant’s responsibility to
            supply the correct contact details and keeping details up to date.
          </li>
          <li class="mb-1 last:mb-0">
            The organiser reserves the right to refuse any person’s entry.
          </li>
          <li class="mb-1 last:mb-0">
            Every entrant shall participate carefully and with due regard to the
            safety of other participants and other road users.
          </li>
          <li class="mb-1 last:mb-0">
            In a cycle event, every rider shall wear a bicycle helmet with the
            strap securely fastened under his/her chin.
          </li>
          <li class="mb-1 last:mb-0">
            Every participant shall immediately comply with the instructions of
            a marshal and/or a traffic officer.
          </li>
          <li class="mb-1 last:mb-0">
            A participant may not use a personal music system, e.g. iPod, or a
            radio communication device, including a cellular phone, whilst
            riding.
          </li>
          <li class="mb-1 last:mb-0">
            A participant shall not use foul or offensive language or make
            offensive, indecent or inappropriate gestures.
          </li>
          <li class="mb-1 last:mb-0">
            A participant shall wear clothing appropriate for a family event at
            all times.
          </li>
          <li class="mb-1 last:mb-0">
            A participant shall not dispose of any litter along the race course
            except in refuse bins.
          </li>
          <li class="mb-1 last:mb-0">
            A participant shall provide reasonable assistance to any other
            participants involved in an accident while competing in the event.
          </li>
          <li class="mb-1 last:mb-0">
            For a cycling race, a rider shall be responsible to other riders for
            the proper control of his/her bicycle.
          </li>
          <li class="mb-1 last:mb-0">
            A participant may not participate whilst under the influence of
            alcohol or any drug or medication that prevents or might prevent a
            participant from properly participating in the event.
          </li>
          <li class="mb-1 last:mb-0">
            A participant shall not display on his/her bicycle, clothing and
            cycling equipment any writing, logo or item that is offensive.
          </li>
          <li class="mb-1 last:mb-0">
            Any reasonable medical or emergency evacuation costs incurred on
            behalf of a participant by the race organisers will be for the cost
            of the participant.
          </li>
        </ul>

        <p class="mt-5">10. Photographs taken at the event</p>
        <p class="mt-5">
          The organiser and/or Hype Nation and their service providers reserve
          the right to use any photograph/video taken at any organized or
          sponsored event, without the expressed written permission of those
          included within the photograph/video. The organiser and/or Hype Nation
          and their service providers may use the photograph/video in
          publications or other media material produced, used or contracted,
          including but not limited to; brochures, invitations, newspapers,
          magazines, presentations, websites, etc. A person attending an event
          who does not wish to have their image recorded for distribution should
          make their wishes known to the photographer, and/or the event
          organizers, in writing of his/her intentions. By participating in an
          event or by failing to notify, in writing, your desire to not have
          your photograph used by the organiser and/or Hypenation, you are
          agreeing to release, defend, hold harmless and indemnify the organiser
          and/or Hypenation from any and all claims involving the use of your
          picture or likeness. Any person or organization not affiliated with
          the organiser and/or Hypenation may not use, copy, alter or modify the
          photographs, graphics, videography or other, similar reproductions or
          recordings without the advance written permission of an authorized
          designee of the organiser and/or Hypenation.
        </p>
        <p class="mt-5">11. What happens with your personal information?</p>
        <p class="mt-5">
          You expressly agree that we may collect, use and share your personal
          information on the basis and with the people as described below. When
          you create a profile and enter an event, we ask for information. This
          includes demographic information and information about your health.
          Your health information includes information about your medical aid
          and previous medical conditions. You, or the person who has entered
          you, are our source where we get your information from. We only use
          the information to organise the event you have entered, to communicate
          with you about other events we are involved in and to send you
          promotional material from the sponsors of the event you participate
          in.
        </p>
        <p class="mt-5">
          You agree that we may share your personal information with the Sports
          Association for this type of event and the event organisers of events
          you enter, and we may give your medical information to any emergency
          or health professional attending to you on event day for purposes of
          giving you medical treatment and care. We will not give your
          information to anyone else.
        </p>
        <p class="mt-5">
          I affirm that I am of legal age and am freely signing this Agreement.
          I have read this Agreement and fully understand that I am giving up
          legal rights and remedies that I might have now or in the future.
        </p>
        <p class="mt-5">
          If the participant is a minor, I affirm that I am of legal age and am
          the parent or legal guardian of that minor. On behalf of the minor, I
          have read this Agreement and fully understand that I am giving up
          legal rights and remedies that I, my spouse, a legal guardian for the
          minor, or the minor might have now or in the future.
        </p>
        <p class="mt-5">12. What is our REFUND POLICY</p>
        <p class="mt-5">
          REFUNDS will be assessed on a case by case basis. NO REFUNDS if you
          register and don’t pitch up on race day.
        </p>
        <div
          class="mt-8 pt-5 border-t border-slate-200/60 dark:border-darkmode-400"
        >
          <a
            href="/hactnc.pdf"
            target="_blank"
            class="inline-flex items-center text-blue-600 hover:text-blue-800  transition-colors"
          >
            <svg
              class="w-4 h-4 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              ></path>
            </svg>
            <span class="text-bold font-medium"> HAC EVENTS : </span>
            <span class="ml-2 underline"
              >VIEW HARARE ATHLETIC CLUB GENERAL CONDITIONS OF ENTRY
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
